import React from 'react';
import { Box } from '@mui/material';
import AnalyticsPanel from '../components/AnalyticsPanel';

// Thin wrapper — the page heading ("Insights") is rendered by the top bar; the
// panel owns its own sub-header, filters, KPIs, charts and insight tables.
const AnalyticsPage = () => (
  <Box sx={{ p: 3 }}>
    <AnalyticsPanel />
  </Box>
);

export default AnalyticsPage;
